<template>
  <v-app id="inspire">
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4>
            <v-card class="elevation-12">
              <v-toolbar dark color="light-blue darken-3">
                <v-avatar
                  :tile="tile"
                  :size="avatarSize"
                  style="margin-left: 16px !important;"
                >
                  <img src="https://cdn.vuetifyjs.com/images/logos/v-alt.svg" alt="avatar">
                </v-avatar>
                <v-toolbar-title>{{ title }}</v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                <v-form ref="passwordResetForm" v-model="valid" lazy-validation>
                  <v-text-field prepend-icon="email" name="login" label="E-mail" type="email" v-model="email" :rules="emailRules"></v-text-field>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="light-blue darken-3" dark @click.native="send">Pošlji</v-btn>
                <v-btn color="light-blue darken-3" dark @click.native="login">Prijava</v-btn>
                <br><br>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import router from '../.././router'

  export default {
    data: () => ({
      drawer: null,
      tile: true,
      avatarSize: 32,
      title: 'Ponastavitev gesla',
      valid: true,
      email: "",
      emailRules: [
        (v) => !!v || 'Elektronski naslov je obvezen.',
        (v) => /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'Vneseni elektronski naslov ni veljaven.'
      ],
      password: "",
      password_confirmation: "",
      sending: false
    }),
    props: {
      source: String
    },

    methods: {
      login() {
        router.push({ name: 'login'});
      },

      send() {
        if(this.$refs.passwordResetForm.validate()) {
          router.push({ name: 'login'});
        }
      }
    }
  }
</script>

<style scoped>
    .v_text_field_border_bottom input {

    }
</style>
